import { render, staticRenderFns } from "./RssItem.vue?vue&type=template&id=685413fb&scoped=true"
import script from "./RssItem.ts?vue&type=script&lang=ts&external"
export * from "./RssItem.ts?vue&type=script&lang=ts&external"
import style0 from "./RssItem.vue?vue&type=style&index=0&id=685413fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685413fb",
  null
  
)

export default component.exports